import config from './config';
import { asArray, makeFrom } from './utils';
import { enqueue } from './enqueue';
export function sendEmail(email) {
    const doSendEmail = async (to, data, options) => {
        const subject = email.genSubject(data);
        const body = email.genTemplate(data);
        await enqueue({
            body,
            subject,
            replyTo: options.replyTo || options.from || config.emailFrom,
            to: asArray(to),
            cc: asArray(options?.cc),
            bcc: asArray(options?.bcc),
            deduplicationId: options?.deduplicationId,
            attachments: asArray(options?.attachments),
            from: makeFrom(options.from || config.emailFrom, options.fromName)
        });
    };
    return doSendEmail;
}
